import React from "react";

function Back() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.785 8.75H20V11.25H4.785L11.485 17.95L9.718 19.717L0 10L9.722 0.278L11.49 2.046L4.785 8.75Z"
        fill="var(--black)"
      />
    </svg>
  );
}

export default Back;
